var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-skeleton',{attrs:{"row":3,"loading":_vm.loading}},_vm._l((_vm.imgs),function(img,i){return _c('div',{key:i},[_c('img',{staticClass:"onlyPrintShow",style:(img.style),attrs:{"src":img.base64}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }